import { Grid, Text } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { PersonVerificationDetails } from 'shared/components/(wallets)/kyc/PersonVerificationDetails';

import { messages } from './DetailsStep.messages';

export const DetailsStep = () => {
    const [companyName] = hooks.useQueryParam('companyName');

    return (
        <Grid gap={24}>
            <Text font='body' fontSize='medium' fontWeight='regular'>
                {messages.pleaseProvideInfo({ companyName: <b>{companyName}</b> })}
            </Text>

            <PersonVerificationDetails />
        </Grid>
    );
};

DetailsStep.displayName = 'DetailsStep';
